import { Link } from 'react-router-dom';
import { ComicArticle } from '@/mocks/comics';

interface ComicCardProps {
  comic: ComicArticle;
  variant?: 'default' | 'featured' | 'compact';
}

export default function ComicCard({ comic, variant = 'default' }: ComicCardProps) {
  return (
    <Link
      to={`/article/${comic.id}`}
      className={`group block rounded-lg overflow-hidden transition-all duration-300 hover:-translate-y-1 bg-background-50 ${
        variant === 'featured' ? 'border border-secondary-200/70' : ''
      }`}
    >
      <div className={`relative overflow-hidden ${variant === 'featured' ? 'aspect-[3/4]' : 'aspect-[2/3]'}`}>
        <img
          src={comic.coverImage}
          alt={comic.title}
          title={`${comic.title} - 韩漫在线阅读推荐`}
          className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300" />

        {comic.newRelease && (
          <span className="absolute top-2 left-2 bg-accent-500 text-background-50 text-xs font-bold px-2 py-1 rounded-md whitespace-nowrap">NEW</span>
        )}
        {comic.trending && !comic.newRelease && (
          <span className="absolute top-2 left-2 bg-primary-500 text-background-50 text-xs font-bold px-2 py-1 rounded-md whitespace-nowrap">热门</span>
        )}

        <div className="absolute bottom-0 left-0 right-0 p-3 opacity-0 group-hover:opacity-100 transition-opacity duration-300">
          <div className="flex items-center gap-2 text-background-50 text-xs">
            <div className="w-3 h-3 flex items-center justify-center">
              <i className="ri-star-fill text-accent-400 text-xs"></i>
            </div>
            <span className="font-medium">{comic.rating}</span>
            <span className="mx-1">|</span>
            <div className="w-3 h-3 flex items-center justify-center">
              <i className="ri-eye-line text-xs"></i>
            </div>
            <span>{comic.views > 10000 ? `${(comic.views / 10000).toFixed(0)}万` : comic.views}</span>
          </div>
        </div>
      </div>

      <div className="p-3">
        <h3 className="text-foreground-900 font-bold text-sm leading-tight line-clamp-1 group-hover:text-primary-600 transition-colors">
          {comic.title}
        </h3>
        {variant !== 'compact' && (
          <p className="text-foreground-500 text-xs mt-1 line-clamp-2 leading-relaxed">
            {comic.shortDescription}
          </p>
        )}
        <div className="flex items-center gap-2 mt-2">
          <span className="text-foreground-400 text-xs whitespace-nowrap">{comic.author}</span>
          <span className="text-foreground-300 text-xs">·</span>
          <span className="text-secondary-500 text-xs whitespace-nowrap">{comic.chapters}话</span>
        </div>
      </div>
    </Link>
  );
}